<template>
  <b-modal
    id="awards-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
    ref="awardsModal"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Lista de prêmios
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div
        v-if="list.length > 0"
      >
        <div
          v-for="award in list"
          :key="award.id"
        >
          <template v-if="type !== 'user' || (award.entities && award.entities.length <= 0)">
            <div class="d-flex align-items-center mb-3">
              <div class="icon mr-3">
                <img :src="award.icon" :alt="award.name" />
              </div>
              <div class="font-size-small">
                <span class="d-block font-weight-bold">{{ award.name }}</span>
                <span class="d-block">{{ award.description }}</span>
              </div>
            </div>
          </template>
          <template v-else-if="award.entities && award.entities.length > 0">
            <div
              v-for="entity in award.entities"
              :key="entity.id"
              class="d-flex align-items-center mb-3"
            >
              <div class="icon mr-3">
                <img :src="award.icon" :alt="award.name" />
              </div>
              <div class="font-size-small">
                <span class="d-block font-weight-bold">{{ award.name }}</span>
                <span class="d-block">{{ award.description }}</span>
                <span
                  class="d-block"
                  v-if="entity.type === 'post'"
                >
                  <strong>Publicação:</strong>
                  <router-link
                    class="link-color2"
                    :to="{ name: 'posts.show', params: { username: entity.entity.user.username, slug: entity.entity.slug } }"
                  >
                    {{ entity.entity.title }}
                  </router-link>
                </span>
                <span
                  class="d-block"
                  v-else-if="entity.type === 'book'"
                >
                  <strong>Livro:</strong>
                  <router-link
                    class="link-color2"
                    :to="{ name: 'books.show', params: { username: entity.entity.user.username, slug: entity.entity.slug } }"
                  >
                    {{ entity.entity.title }}
                  </router-link>
                </span>
              </div>
            </div>
          </template>
        </div>
        <div class="text-center mt-3">
          <Button
            class="btn btn-outline-color2 btn-sm"
            :loading="loader"
            v-if="isLoadMoreVisible"
            @click="loadMore"
          >
            Carregar mais
          </Button>
        </div>
      </div>
      <Loader
        color="color2"
        size="big"
        v-else-if="loader"
      />
      <p class="text-center font-size-small" v-else>Sem prêmios no momento</p>
    </template>
  </b-modal>
</template>

<script>

import AwardsService from '@/modules/awards/services/awards-service'

import { mapState } from 'vuex'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'AwardModal',
  props: ['target', 'type'],
  data () {
    return {
      errors: null,
      list: [],
      loader: false,
      isLoadMoreVisible: true,
      page: 1
    }
  },
  components: {
    AlertWraper,
    Button,
    Loader
  },
  computed: {
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  methods: {
    async getList () {
      this.errors = null
      this.loader = true
      try {
        console.log(this.type)
        const list = await AwardsService.getAwards({ type: this.type, target: this.target, page: this.page, awardables: this.type === 'user' })
        this.list = [...this.list, ...list]
        this.isLoadMoreVisible = list.length > 0
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getList()
    },
    shown () {
      this.getList()
    },
    hidden () {
      this.errors = null
      this.list = []
      this.page = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 40px;
  flex-shrink: 0;
}
</style>
